import React, { useState } from "react";
import { Link } from "react-router-dom";
import loginImage from '../../assets/images/login.jpg';
import logo from "../../assets/images/logo.png";
import ForgotPasswordForm from "../../components/auth/login/ForgotPasswordForm";
import LoginForm from "../../components/auth/login/LoginForm";
import OtpVerifyForm from "../../components/auth/login/OtpVerifyForm";
import ResetPassword from "../../components/auth/login/ResetPassword";

const Login = () => {
  const [formType, setFormType] = useState("login");

  const handleFormChange = (type) => {
    setFormType(type);
  };
  return (
    <>
      <div class="flex w-screen flex-wrap text-slate-800">
        <div
          className="relative hidden h-screen select-none flex-col justify-center  text-center md:flex md:w-1/2"
          style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: "cover",
          }}
        >
         
        </div>
        <div class="flex w-full flex-col md:w-1/2">
          <div class="flex justify-center pt-12 md:justify-start md:pl-12">
            <Link to="/">
              <img src={logo} className="w-40" alt="logo"/>
            </Link>
          </div>
          {formType === "login" && (
            <LoginForm onFormChange={handleFormChange} />
          )}
          {formType === "forgotPassword" && (
            <ForgotPasswordForm onFormChange={handleFormChange} />
          )}
          {formType === "otp" && (
            <OtpVerifyForm onFormChange={handleFormChange} />
          )}
          {formType === "resetPassword" && (
            <ResetPassword onFormChange={handleFormChange} />
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
